import React from 'react'
import PlatformInsights from '../components/PlatformInsights'
import BlogSection from '../components/BlogSection'
import ServiceStatsCards from '../components/ServiceStatsCards'
import WhyChooseUs from '../components/WhyChooseUs'
import ExperienceSection from '../components/ExperienceSection'
import Certifications from '../components/Certifications'
import CheckCategories from '../components/CheckCategories'


const InstantChecksPage = () => {
  return (
    <>
        <PlatformInsights/>
        <ServiceStatsCards/>
        <WhyChooseUs/>
        <ExperienceSection/>
        <CheckCategories/>
        <Certifications/>
        <BlogSection/>
    </>
  )
}

export default InstantChecksPage